import { render, staticRenderFns } from "./FoodCourtCart.vue?vue&type=template&id=35645f5a&scoped=true"
import script from "./FoodCourtCart.vue?vue&type=script&lang=js"
export * from "./FoodCourtCart.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtCart.vue?vue&type=style&index=0&id=35645f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35645f5a",
  null
  
)

export default component.exports